export const CREDIT_UNION = {
    INFO: {
      NAME: 'Diversified Members Credit Union',
      PHONE: '313-752-0787',
      CONTACT: '+13137520787',
      EMAIL: 'ask@autorefi.dmcu.com',
    },
    LINKS: {
      WEBSITE: 'https://dmcu.com/',
      BRANCH_LOCATOR: 'https://dmcu.com/locations/',
      APPLICATION: 'https://www.heritageccu.com/apply-now',
      PRIVACY_POLICY: 'https://dmcu.com/wp-content/uploads/2024/06/Privacy-Notice-6.24.pdf'
    },
    SUPPORT: {
      SPANISH_PHONE: '800-914-7536',
    },
    ABOUT: {
      TEXT: 'Here at DMCU, we work hard to serve our members and the communities in which we operate. We serve over 30,000 members and have locations in Novi, Clawson, and Detroit. We offer technology services like Online Banking and Mobile Banking to stay competitive and meet the demands of a changing market. We urge you to invite your family, friends, co-workers and neighbors to join DMCU!',
    },
  };
  
  export const FAQ_LIST = [
    {
      id: 'faq1',
      question: 'Is there a fee to apply?',
      answer: 'There is no fee to apply.',
    },
    {
      id: 'faq2',
      question: 'Once I am pre-qualified, when does my offer expire?',
      answer: 'Your offer expires 6 weeks after you have been pre-qualified. You may use your offer up to the expiration date. If your offer expires before you are ready to refinance your vehicle, you are still welcome to apply, rates and payments are subject to change due to market conditions.',
    },
    {
      id: 'faq3',
      question: "What if I don't have excellent credit?",
      answer: 'All credit scores are welcome! In fact, those with less-than-perfect credit often find more savings. Apply now to see what your savings might be every month. If you received an offer of credit letter with a promo code, you were already pre-qualified at that time and meet our initial credit criteria.',
    },
    {
      id: 'faq4',
      question: 'Do I have to extend the term of my current loan?',
      answer: 'You are not required to extend your loan beyond your current term. In some cases, this may be required to meet lending requirements or if you are trying to maximize your monthly savings.',
    },
    {
      id: 'faq5',
      question: 'Is my personal information secure?',
      answer: {
        type: 'link',
        text: 'Diversified Members Credit Union and our marketing partner take the security of your personal information seriously. Please review our ',
        linkText: 'privacy policy',
        href: 'https://dmcu.com/wp-content/uploads/2024/06/Privacy-Notice-6.24.pdf',
        postText: ' on our corporate website for details.',
      },
    },
    {
      id: 'faq6',
      question: 'What does pre-qualification mean?',
      answer: 'Pre-qualification refers to being pre-approved based on the credit information provided to our financial institution by the credit bureaus. You were selected based on your credit score falling within an acceptable range. Other factors need to be reviewed before approval, like the vehicle information and your current employment information.',
    },
    {
      id: 'faq7',
      question: 'How do I benefit by refinancing my auto loan?',
      answer: 'In most cases, if you financed through a dealership, you would probably save a significant amount by refinancing. Or if your credit score increased since purchasing the vehicle, you may qualify now for a lower rate.',
    },
    {
      id: 'faq8',
      question: 'What documents will I need to provide the lender?',
      answer: {
        type: 'list',
        text: 'In general, these documents will be required:',
        items: [
          "Driver’s License",
          "Registration",
          "Proof of Insurance",
          "Proof of Income",
          "Title: if you are in a state where you are responsible for holding the vehicle title, you will need to provide it for the title to be perfected for the new lender",
          'Other documentation may be required.'
        ],
      },
    },
  ];